webpackJsonp([203743091051260],{

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'To clarify the federal government\'s definitions of a churches and other religious institution, the Internal Revenue Service uses clearly-defined guidelines. Over the years, the IRS has revised this list in response to various court decisions. To define churches and other religious entities, some of the IRS guidelines consider whether or not an institution has:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'A distinct legal existence and religious history,'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'A recognized creed and form of worship,'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Established places of worship'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'A regular congregation and regular religious services, and'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'an organization of ordained ministers'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Most mainstream religions such as Catholicism, Judaism, and common Protestant sects fit easily within the IRS guidelines. However, churches that are less traditional sometimes face difficulty in meeting the federal government\'s definition.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Church Organization Information',
	  fields: new Map([['orgName', {
	    label: 'Church Name'
	  }], ['dba', {
	    'data-help-text': 'Please enter the trade name of the organization.'
	  }]])
	}, {
	  legend: 'Responsible Party Information',
	  fields: new Map([['firstName', {
	    'data-help-title': 'Responsible Party',
	    'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['middleName', {
	    'data-help-title': 'Responsible Party',
	    'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['lastName', {
	    'data-help-title': 'Responsible Party',
	    'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['socialSecurity', {
	    'data-help-title': 'Responsible Party',
	    'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['verifySocialSecurity', {
	    'data-help-title': 'Responsible Party',
	    'data-help-text': 'A Responsible Party is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['title', {
	    label: "Officer's Title",
	    placeholder: 'Mangaing Member',
	    'data-help-title': 'Mangaing Member',
	    'data-help-text': 'A Mangaing Member is a person who has a level of control over or entitlement to the funds or assets of an entity.'
	  }], ['suffix', {
	    initial: 'MD'
	  }]])
	}, {
	  legend: 'Business Address (No PO Boxes)',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Business Information',
	  fields: new Map([['businessIncCountry', {
	    label: 'Where was the Corporation organized?'
	  }], ['businessApplyReason'], ['businessActivity'], ['businessServices'], ['commonQuestionOne'], ['commonQuestionTwo'], ['commonQuestionThree'], ['commonQuestionFour'], ['businessAppliedBefore'], ['businessHireEmployees']])
	}, {
	  legend: 'Business Dates',
	  fields: new Map([['businessDateStart'], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify', {
	    label: 'Verify Contact E-mail'
	  }]])
	}];
	
	var ChurchOrganizationApplicationPage = function ChurchOrganizationApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Church Organization Application',
	    documentType: _data.documentTypes.CHURCH_CONTROLLED_ORGANIZATION,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = ChurchOrganizationApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-church-organization-application-js-1f48ef882a0a62ba8a68.js